module.exports = {"transaction_id":"Transaction ID","username":"Employee","description":"Description","time":"Time","type":"Type"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/management/diary.json
// module id = 1z8r
// module chunks = 58